export default "__VITE_ASSET__BkBfBshw__"